import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import '@mdi/font/css/materialdesignicons.css'
import router from './router'
import 'material-design-icons-iconfont/dist/material-design-icons.css';
export function toggleModoOscuro(activar) {
    document.documentElement.setAttribute('data-tema', activar ? 'oscuro' : '');
  }
  const temaGuardado = localStorage.getItem('tema') || 'claro';
  document.documentElement.setAttribute('data-tema', temaGuardado === 'oscuro' ? 'oscuro' : '');
  
Vue.use(Buefy)

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
